import './style.css'
import { md2html } from "./converter"
import { MdFormat } from "./types"
import { useTranslation } from 'react-i18next'
import { JSX } from 'react'

export const I18nMd = ({value, variables={}, whitelist=null, style={}}:{ value:string, variables?:{[key:string]:string|number}, whitelist?:MdFormat[]|null, style?:object}) => {
  const { t } = useTranslation()
  const content = md2html(t(value, variables), null, whitelist, 'per-paragraph')
  return <div className="pretty-markdown-input" style={{border:"none", ...style}} dangerouslySetInnerHTML={{__html: content.replace(/\n/g, '')}} /> as JSX.Element
}


export default I18nMd